import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";

const API_BASE = process.env.REACT_APP_API_URL || "";
const _nativeFetch = window.fetch.bind(window);

function readCookie(name) {
  const m = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
  return m ? decodeURIComponent(m[1]) : null;
}

window.fetch = (input, init = {}) => {
  const url = input instanceof Request ? input.url : String(input);
  const token = readCookie("token");
  if (API_BASE && token && url.startsWith(API_BASE)) {
    const headers = new Headers(init.headers || (input instanceof Request ? input.headers : {}));
    if (!headers.has("Authorization")) headers.set("Authorization", `Bearer ${token}`);
    init = { ...init, headers };
  }
  return _nativeFetch(input, init);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);


